import { useState, useCallback, useEffect } from "react";
import { financialsService } from "../services/financialsService";

const defaultFilters = {
  from: "",
  to: "",
  month: "",
  year: "",
  expectedDeliveryPercentage: "",
  customProductCostRatio: "",
  agencyCommissionPercentage: "",
};

export function useFinancials() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState(defaultFilters);

  const loadIncomeStatement = useCallback(async (customFilters) => {
    setLoading(true);
    setError(null);
    try {
      const res = await financialsService.getIncomeStatement(customFilters ?? filters);
      setData(res?.data || null);
    } catch {
      setError("حدث خطأ أثناء جلب القوائم المالية");
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loadIncomeStatement();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const resetFilters = () => {
    setFilters(defaultFilters);
    loadIncomeStatement(defaultFilters);
  };

  return { data, loading, error, filters, setFilters, loadIncomeStatement, resetFilters };
}